package com.essntl.features.contact.ui

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.contact.domain.model.ContactModel
import com.essntl.features.contact.domain.model.GetContactModel

data class ContactState(
    val getAllContacts: State<List<GetContactModel>> = State(),
    val getContact: State<ContactModel> = State(),
    val editContact: State<ContactModel> = State(),
    val contact: MutableState<ContactModel> = mutableStateOf(ContactModel.empty),
    val addAddress: Boolean = false,
)